<template>
  <router-view />
</template>
<script>
  export default {
    name: 'ProdutorModule',
  }
</script>
